import React from "react";

const PlayerCard = ({ isUserOrganizer, playerId, profile }) => {
  const showInformation = isUserOrganizer && !!profile;

  const cardClasses =
    "w-full max-w-xs p-4 m-2 bg-white rounded-2xl shadow-md border border-stone-300";

  const labelValue = (label, value) => (
    <div className="flex justify-between text-sm text-gray-600">
      <span className="font-medium">{label}</span>
      <span className="text-gray-800">{value || "N/A"}</span>
    </div>
  );

  return (
    <div className={cardClasses}>
      <div className="flex justify-between items-center mb-3">
        <h2 className="text-lg font-semibold text-gray-900 truncate">
          {profile?.name || playerId}
        </h2>
        {showInformation && (
          <span className="bg-blue-100 text-blue-800 text-md font-semibold px-3 py-0.5 rounded-full">
            {profile?.skill}
          </span>
        )}
      </div>

      {showInformation && (
        <div className="space-y-2">
          {labelValue("Pronouns", profile?.pronouns)}
          {labelValue("Club", profile?.club)}
          {labelValue("Region", profile?.region)}
        </div>
      )}
    </div>
  );
};

export default PlayerCard;
